export default __webpack_public_path__ + "static/media/shoppinglist@2x.0495b875.png";